import React, {useEffect, useRef, useState} from "react";

import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import BreathalyzerNew from "./BreathalyzerNew";
import {breathalyzersService} from "../../../services/breathalyzersService";
import Loading from "../../../components/Loading/Loading";

function BreathalyzerEdit() {

    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({
        brand: "",
        model: "",
        serialNumber: "",
        observations: ""
    });

    useEffect(() => {
        if (id) {
            setIsLoading(true);
            breathalyzersService.find(+id).then((breathalyzerDetails) => {
                setFormData((prevData) => ({
                    ...prevData,
                    id: breathalyzerDetails.id,
                    brand: breathalyzerDetails.marca,
                    model: breathalyzerDetails.modelo,
                    serialNumber: breathalyzerDetails.numero_serie,
                    observations: breathalyzerDetails.observacoes
                }));
            })
            .finally(() => {
                setIsLoading(false);
            })
        } else {
            setIsLoading(false);
        }
    },[id])

    return (
        <>
            {isLoading ? (<Loading />) : (<BreathalyzerNew data={formData}></BreathalyzerNew>)}
        </>
    );
}

export default BreathalyzerEdit;
